export default __webpack_public_path__ + "static/media/README.9a18facd.md";